import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-route-logged',
  templateUrl: './route-logged.component.html',
  styleUrls: ['./route-logged.component.less']
})
export class RouteLoggedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/route-logged/route-logged.component.ts